import 'photoswipe/dist/photoswipe.css';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import galleryService from 'common/util/galleryService';

export default () =>
	Component(
		function ($context) {
			return $context.select('.product-images');
		},
		function ($product_images, self) {
			let photoSwipeLightbox = new PhotoSwipeLightbox({
				pswpModule: PhotoSwipe
			});
			photoSwipeLightbox.on('change', () => {
				let photoSwipe = photoSwipeLightbox.pswp;
				let currSlide = photoSwipe.currSlide;

				if (currSlide.data.width > 1 && currSlide.data.height > 1) {
					return;
				}

				let image = new Image();
				image.src = currSlide.data.src;

				image.onload = () => {
					currSlide.data.width = image.width;
					currSlide.data.height = image.height;
					photoSwipe.refreshSlideContent(photoSwipe.currIndex);
				};
			});
			photoSwipeLightbox.init();
			$.extend(self, {
				initSwiper: function () {
					var initial_slide = 0;

					if ($product_images.hasClass('product-images_has-video')) {
						initial_slide = 1;
					}

					var $thumbs = $product_images.find('.product-images__thumbs');
					var thumbs_swiper = null;

					if ($thumbs.length !== 0) {
						thumbs_swiper = new window.Swiper($thumbs.find('.swiper-container').get(0), {
							slidesPerView: 'auto',
							direction: 'vertical',
							watchSlidesVisibility: true,
							navigation: {
								prevEl: $thumbs.find('.swiper-button-prev'),
								nextEl: $thumbs.find('.swiper-button-next')
							}
						});
					}

					var $images = $product_images.find('.product-images__images');

					var thumbs_config = {};

					if (ResponsiveUtil.isDesktopUp()) {
						thumbs_config.swiper = thumbs_swiper;
					}

					var images_swiper = new window.Swiper($images.get(0), {
						initialSlide: initial_slide,
						thumbs: thumbs_config,
						watchSlidesVisibility: true,
						slidesPerView: 'auto',
						pagination: {
							el: '.product__images-pagination',
							clickable: true,
							bulletClass: 'product__images-pagination-bullet',
							bulletActiveClass: 'product__images-pagination-bullet_active',
							currentClass: 'product__images-pagination-bullet_active',
						},
						allowTouchMove: !ResponsiveUtil.isDesktopUp(),
						on: {
							slideChange() {
								if (!ResponsiveUtil.isDesktopUp()) {
									return;
								}

								let slide = this.slides[this.activeIndex];

								if (slide.zoomInited) {
									return;
								}

								slide.zoomInited = true;
								let $imgWrapper = $(slide).find('.product-images__img-wrapper');
								let $img = $imgWrapper.find('.product-images__img');

								function initZoom() {
									if ($img.prop('naturalHeight') < $img.prop('height') || $img.prop('naturalWidth') < $img.prop('width')) {
										return;
									}

									$imgWrapper.zoom({
										url: $imgWrapper.data('original')
									});
								}

								if ($img.prop('complete') && $img.prop('naturalWidth') > 1 && $img.prop('naturalHeight') > 1) {
									initZoom();
									return;
								}

								$img.one('load', function () {
									initZoom();
								});
							}
						}
					});

					if (self.hasVideo()) {
						$product_images.find('.product-video').on('click', () => {
							images_swiper.slideTo(0, 200);
						});

						images_swiper.on('slideChange', function () {
							var isVideoSlide = images_swiper.activeIndex === 0;

							$product_images.find('.product-images__labels').toggle(!isVideoSlide);
							self.toggleHint(!isVideoSlide);
						});
					}

					$images.find('.product-images__img').on('click', function (e) {
						e.preventDefault();

						galleryService.open(images_swiper.realIndex, $product_images.data('gallery'));
					});
				},
				initZoom: function () {
					if (ResponsiveUtil.isIE()) {
						return;
					}

					var $images = $product_images.find('.product-images__images');

					if (!ResponsiveUtil.isDesktopUp()) {
						$images.find('.image').each(function () {
							var imgBlock = $(this).get(0);
							var pz = new PinchZoom(imgBlock, {
								draggableUnzoomed: false
							});
						})
					}
				},
				initHint: function () {
					var $hint = $product_images.find('.product-images__images-hint');
					$hint.html($hint.data('general-hint'));

					$product_images.find('.product-images__images').on('mouseenter', () => {
						$hint.html($hint.data('hover-hint'));
					}).on('mouseleave', () => {
						$hint.html($hint.data('general-hint'));
					});
				},
				toggleHint: function(toToggle) {
					var $hint = $product_images.find('.product-images__images-hint');

					if (toToggle)
						$hint.css('visibility', 'visible');
					else
						$hint.css('visibility', 'hidden');
				},
				hasVideo: function() {
					return $product_images.hasClass('product-images_has-video');
				}
			});

			self.initSwiper();
			self.initZoom();

			if (ResponsiveUtil.isDesktopUp()) {
				self.initHint();
			}
		}
	);
